export default [
  // Redirect to '/dash' when user click on home icon from breadcrumb. home path is '/' so redirect to '/dash'
  {
    path: "/search-people",
    name: "SearchPeople",
    component: () => import("@/modules/searchPeople/pages/SearchPeople.vue"),
    meta: {
      authRequired: true,
      pageTitle: "Search People",
      breadcrumb: [
        {
          text: "Search People",
          active: true,
        },
      ],
    },
  },
];
